import React, { FC, useState } from "react";
import { Box, Button, CircularProgress, Modal, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

interface ActionConfirmationModalProps {
    visible: boolean;
    onClose: () => void;
    onConfirm: () => Promise<void>;
    headerText: string;
    bodyText: string;
}

const styles = {
    modal: {
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '30%',
        bgcolor: 'background.paper',
        borderRadius: 4,
        boxShadow: 24,
        p: 2,
        overflowY: 'auto'
    },
    horizontal: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    headerText: {
        fontSize: 18,
        fontWeight: '600'
    },
    body: {
        pt: 4,
        pb: 4,
    },
};

const ActionConfirmationModal: FC<ActionConfirmationModalProps> = ({
    visible, onClose, onConfirm, headerText, bodyText
}) => {
    const [loading, setLoading] = useState<boolean>(false);

    const submit = async () => {
        try {
            setLoading(true);
            await onConfirm();
            onClose();
        } catch (error) {
            console.error('Error: ', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal open={visible} onClose={onClose}>
            <Box sx={styles.modal}>
                <Box sx={styles.horizontal}>
                    <Typography sx={styles.headerText}>{headerText}</Typography>
                    <Button onClick={onClose}>
                        <CloseIcon />
                    </Button>
                </Box>
                <Typography sx={styles.body}>{bodyText}</Typography>
                <Button fullWidth variant="contained" color="primary" onClick={submit}>
                    {loading ? (
                        <CircularProgress color="inherit" />
                    ) : (
                        <Typography>Yes</Typography>
                    )}
                </Button>
            </Box>
        </Modal>
    );
};

export default ActionConfirmationModal;
